import data from "../../../../../src/Flash/Flash.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};